export const ageMethod = "age nearest";
export const gateway = "https://qat-hwi-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/hwi";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJod2kiLCJuYW1lIjoiaHdpIiwiaWF0IjoxNzgwNTgyODE2LCJleHAiOjE5MzgzNzA4MTZ9.d7cWKnv2uKsJ4I7vTasMxBTm1kb7IxwkqavBLS87TAY";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-hwi-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_hwi",
			brands: [
				"qat-hwi-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "hwi",
			broker_formatted_name: "Harvard Western Insurance",
			email: "info@harvardwestern.com",
			environment: "qat",
			environment_id: "qat",
			faq_text: "Frequently Asked Questions",
			g4: "GTM-P6HT43K",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"4420 Albert Street",
					"Regina",
					"SK",
					"S4S 6B4",
				],
				"map2": [
					"464 McCarthy Blvd. N.",
					"Regina",
					"SK",
					"S4R 7M2",
				],
				"map1": [
					"3615 Quance Street East",
					"Regina",
					"SK",
					"S4V 3A4",
				],
				"map10": [
					"115 3rd St",
					"Dalmeny",
					"SK",
					"S0K 1E0",
				],
				"map7": [
					"109 Souris Street",
					"Yellow Grass",
					"SK",
					"S0G 5J0",
				],
				"map6": [
					"128 Main Street",
					"Milestone",
					"SK",
					"S0G 3L0",
				],
				"map5": [
					"5 Main Street",
					"Kronau",
					"SK",
					"S0G 2T0",
				],
				"map4": [
					"407 Broad Street",
					"Regina",
					"SK",
					"S4R 1X4",
				],
				"map9": [
					"133 Main Street",
					"Rouleau",
					"SK",
					"S0G 4H0",
				],
				"map8": [
					"200 Mergens Street",
					"Pangman",
					"SK",
					"S0C 2C0",
				],
			},
			menuPhone: "button",
			phone: "1-306-757-1633",
			privacyLink: "https://harvardwestern.com/privacy-policy/",
			render_fake_email_button: "yes",
			website: "https://harvardwestern.com/",
			scope: "hwi#branding#qat-hwi-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-hwi-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_hwi",
			brands: [
				"qat-hwi-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "hwi",
			broker_formatted_name: "Harvard Western Insurance",
			email: "info@harvardwestern.com",
			environment: "qat",
			environment_id: "qat",
			faq_text: "Frequently Asked Questions",
			g4: "GTM-P6HT43K",
			layout: "modern",
			logoPosition: "menu",
			"maps": {
				"map3": [
					"4420 Albert Street",
					"Regina",
					"SK",
					"S4S 6B4",
				],
				"map2": [
					"464 McCarthy Blvd. N.",
					"Regina",
					"SK",
					"S4R 7M2",
				],
				"map1": [
					"3615 Quance Street East",
					"Regina",
					"SK",
					"S4V 3A4",
				],
				"map10": [
					"115 3rd St",
					"Dalmeny",
					"SK",
					"S0K 1E0",
				],
				"map7": [
					"109 Souris Street",
					"Yellow Grass",
					"SK",
					"S0G 5J0",
				],
				"map6": [
					"128 Main Street",
					"Milestone",
					"SK",
					"S0G 3L0",
				],
				"map5": [
					"5 Main Street",
					"Kronau",
					"SK",
					"S0G 2T0",
				],
				"map4": [
					"407 Broad Street",
					"Regina",
					"SK",
					"S4R 1X4",
				],
				"map9": [
					"133 Main Street",
					"Rouleau",
					"SK",
					"S0G 4H0",
				],
				"map8": [
					"200 Mergens Street",
					"Pangman",
					"SK",
					"S0C 2C0",
				],
			},
			menuPhone: "button",
			phone: "1-306-757-1633",
			privacyLink: "https://harvardwestern.com/privacy-policy/",
			render_fake_email_button: "yes",
			website: "https://harvardwestern.com/",
			scope: "hwi#branding#qat-hwi-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-hwi-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 14:20:16 GMT+0000 (Coordinated Universal Time)
